<template>
  <div>
    <b-table striped :items="templateDocs" :fields="templateFields">
      <template slot="enabled" slot-scope="data">
        <label class="switch switch-3d switch-success">
          <input type="checkbox"
                 class="switch-input"
                 v-model="data.item.enabled"
                 @change="updateStatus(data.item)">
          <span class="switch-label"></span>
          <span class="switch-handle"></span>
        </label>
      </template>
    </b-table>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      status: false,
      templateDocs: [],
      templateFields: [
        { key: 'id', sortable: true },
        { key: 'title', sortable: true },
        { key: 'enabled', label: 'Enable' }
      ]
    }
  },
  computed: {
    ...mapGetters(['idToken', 'isAdmin'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isAdmin) {
        Vue.axios.get('/admin/template_docs', { headers: { Authorization: `Bearer ${vm.idToken}` } })
          .then(res => {
            vm.templateDocs = res.data.template_docs
            next()
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        console.log(this.$t('COMMON.MSG_EXPIRED'))
      }
    })
  },
  methods: {
    updateStatus: function (formDoc) {
      var formData = new window.FormData()
      formData.append('enabled', formDoc.enabled)

      Vue.axios.patch('/admin/template_docs/' + formDoc.id, formData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          Vue.toasted.show(this.$t('COMMON.MSG_DATA_UPDATE'))
        }, error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'))
          }
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/formStatus.vue